Vue.component('streamersQueue', {
  template: templates.streamersQueue,
  data() {
    return {
      model: {
        queues: [],
        hasResults: false,
        isLoading: false
      },
      cancelTokenSource: null
    };
  },
  mounted() {
    const c = this;
    c.get();
    c.connect();
  },
  beforeDestroy() {
    const c = this;

    if (c.ws) {
      c.ws.close();
    }
    
    if (c.cancelTokenSource) {
      c.cancelTokenSource.cancel('Request canceled due to component destruction.');
    }
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl());

      c.ws.onmessage = (event) => {

        const messageData = event.data;

        try {

          const parsedData = JSON.parse(messageData);
          if(parsedData.channelId === utils.cookies.get('channelId') && parsedData.message === 'streamer_queue' || parsedData.message === 'streamer_queue_decline' || parsedData.message === 'streamer_queue_accept'){
            c.model.hasResults = false;
            c.model.queues = [];
            c.model.isLoading = false;
            c.get();
          }

        } catch (error) {
          console.error('Error parsing message data:', error);
        }
      
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    get() {
      const c = this;

      userService
        .getSteamerQueue()
        .then((res) => {
          c.model.hasResults = true;
          c.model.queues = res.data;
          c.model.isLoading = true;
        })
        .catch((err) => {
          setTimeout(function () {
            c.model.isLoading = true;
          }, 10000);
        });

      
    },
    accept(data) {
      const c = this;

      let reqData = {
        id: data.id,
        twitchId: data.twitchId,
        teamName: data.teamName,
        streamerUserName: utils.cookies.get('user_login'),
        eventId: null
      };

      userService
        .acceptUserTeam(reqData)
        .then((res) => {
          if(res.data.status === 200){
            c.model.queues = [];
            c.get();
            c.$root.$emit('streamerTeamAccepted');
  
            const messageData = {
              message: 'streamer_queue_accept',
              to: utils.cookies.get('user_id'),
              channelId: utils.cookies.get('channelId'),
              username: data.username,
              teamName: data.teamName
            };
            c.ws.send(JSON.stringify(messageData));
            utils.alert.success(res.data.message);
         
          }
          else{
            utils.alert.show(res.data.message,'error');
          }
          // if (res.data.msg.includes('ERROR')) {
          //   utils.alert.error('Failed to accept user');
          // } else {
          //   const newQueue = c.model.queues.filter(
          //     (queue) => queue.twitchId !== data.twitchId
          //   );
          //   c.model.queues = newQueue;
          //  
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    decline(data) {
      const c = this;

      let reqData = {
        id: data.id,
        twitchId: data.twitchId,
        userName: data.username,
        teamName: data.teamName,
        streamerUserName: utils.cookies.get('user_id'),
      };
      userService
        .declineUserTeam(reqData)
        .then((res) => {
          utils.alert.error(res.data.message);

          const messageData = {
            message: 'streamer_queue_decline',
            channelId: utils.cookies.get('channelId'),
            username: data.username,
            to: data.teamName
          };

          c.ws.send(JSON.stringify(messageData));
          c.get()
          // if (res.data.msg.includes('ERROR')) {
          //   
          // } else {
          //   const newQueue = c.model.queues.filter(
          //     (queue) => queue.twitchId !== data.twitchId
          //   );
          //   c.model.queues = newQueue;
          //   utils.alert.show(res.data.msg);
          // }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cancel(data){

      const c = this;
      
      let reqData = {
        id: data.id,
        twitchId: data.twitchId,
        teamName: data.teamName,
        streamerUserName: utils.cookies.get('user_login'),
        status: 'cancel'
      };

      userService
      .cancelStreamPlayer(reqData)
      .then((res) => {
        console.log(res);
        utils.alert.error(res.data.message);
        c.get()
      })
      .catch((error) => {
        console.log(error);
      });

    }, 
    cardNames(cards){
      return cards.map(card => `${card.name}(${card.tier})`).join(', ');
    }
  },
});
